import { AccessToken } from './../lib/models/AccessToken';
import { StorageKeys } from './StorageKeys';
import Cookies from 'js-cookie'; 
import moment from 'moment';
export class LoginStorage{
    public static saveToken(token:AccessToken,permanent:boolean){
       
        let expire = 1;
        if(permanent)
        {
            const now = moment();
            const expirationDate = moment(token.expire);
            expire = expirationDate.diff(now,'days');
            
        }
        localStorage.setItem(StorageKeys.expirationDate,token.expire)
        Cookies.set(StorageKeys.token,token.token,{
            expires:expire,
            secure: window.location.protocol === 'https:',
            sameSite: 'lax',
        });
    }
    public static getExpDate():string | null{
        return localStorage.getItem(StorageKeys.expirationDate)
    }
    public static saveRefreshToken(token:string){
        localStorage.setItem(StorageKeys.refreshToken,token);
    }
    public static saveSecret(secret?:string){
        if(secret)
        localStorage.setItem(StorageKeys.secret,secret);
    }
    public static getToken():string | undefined | null{
        return Cookies.get(StorageKeys.token);
    }
    public static saveRedirectUrl(url:string){
        localStorage.setItem(StorageKeys.redirectUrl,url);
    }
    public static getRedirectUrl():string | null{
        return localStorage.getItem(StorageKeys.redirectUrl);
    }
    public static clearRedirectUrl(){
        localStorage.removeItem(StorageKeys.redirectUrl);
    }
    public static clearStorage(){
        window.localStorage.removeItem(StorageKeys.expirationDate);
        Cookies.remove(StorageKeys.token);
        window.localStorage.removeItem(StorageKeys.refreshToken);
        window.localStorage.removeItem(StorageKeys.secret);
        window.localStorage.removeItem(StorageKeys.redirectUrl);
    }
}
